import type z from 'zod/v4'
import { relations, sql } from 'drizzle-orm'
import { index, pgTable, text, timestamp, uuid } from 'drizzle-orm/pg-core'
import { createInsertSchema, createSelectSchema, createUpdateSchema } from 'drizzle-zod'

import { user } from '../auth'

export const UserMetadata = pgTable(
  'user_metadata',
  {
    id: uuid().defaultRandom().primaryKey(),
    userId: text()
      .references(() => user.id, { onDelete: 'cascade' })
      .notNull(),
    howDidYouHearAboutPibo: text(),
    occupation: text(),
    createdAt: timestamp({ mode: 'date', withTimezone: true }).defaultNow().notNull(),
    updatedAt: timestamp({ mode: 'date', withTimezone: true }).$onUpdateFn(() => sql`now()`),
  },
  (t) => [index('idx_user_metadata_user').on(t.userId)],
)

export const userMetadataRelations = relations(UserMetadata, ({ one }) => ({
  user: one(user, {
    fields: [UserMetadata.userId],
    references: [user.id],
  }),
}))

export const InsertUserMetadataSchema = createInsertSchema(UserMetadata).omit({
  id: true,
  createdAt: true,
  updatedAt: true,
})

export const UpdateUserMetadataSchema = createUpdateSchema(UserMetadata).partial().omit({
  id: true,
  userId: true,
  createdAt: true,
  updatedAt: true,
})
export const SelectUserMetadataSchema = createSelectSchema(UserMetadata)

export type InsertUserMetadata = typeof UserMetadata.$inferInsert
export type UpdateUserMetadata = z.infer<typeof UpdateUserMetadataSchema>
export type SelectUserMetadata = typeof UserMetadata.$inferSelect
